const now = new Date()
export default {
  schedules: [],        // AGENDAS MOSTRADAS NO DETALHAMENTO DE GRUPO DE AGENDAMENTO
  selectedDays: [],
  studentSchedules: [],
  holidaySchedules: [],
  time: new Date(),
  endTime: now.setHours(now.getHours() + 1)
}
